// environment.base.ts
export const baseEnvironment = {
  urlApiMisnoticias: 'https://misnoticias.mx/wp-json/wp/v2/posts',
  urlApiGrupoAs: 'https://grupoasradio.com.mx/api/v4/app/public/custom/titulo/',
};

export const menuItems = [
  { id: 'home', title: 'Inicio', url: '', icon: 'fa fa-home', boolean: true, isLink: false },
  // { id: 'news-category', title: 'Noticias', url: 'client-categories', icon: 'fa fa-newspaper-o', boolean: true, isLink: true },
  { id: 'about', title: 'Nosotros', url: 'about', icon: 'fa fa-users', boolean: true, isLink: true },
  { id: 'app', title: 'Aplicación', url: 'app', icon: 'fa fa-play-circle', boolean: false, isLink: true },
  { id: 'social-media', title: 'Redes', url: 'social-media', icon: 'fa fa-share-alt', boolean: false, isLink: true },
  { id: 'news', title: 'Noticias', url: '', icon: 'fa fa-newspaper-o', boolean: true, isLink: false },
  { id: 'contact', title: 'Contacto', url: 'contact', icon: 'fa fa-globe', boolean: true, isLink: true },
];

export const homeSections = [
  { component: 'app-cover', boolean: true },
  { component: 'app-news', boolean: true },
  { component: 'app-client-categories', boolean: true },
  { component: 'app-about', boolean: true },
  { component: 'app-aplication', boolean: false },
  { component: 'app-social-media', boolean: true },
  { component: 'app-program', boolean: false },
  { component: 'app-contact', boolean: true },
];

export const defaultConfig = {
  amountNews: 3,
};

const DEFAULT_CONFIG = {
  name: 'default',
  urlApi: '',
  idStation: '',
  skin: 'default',
  excludeId: '',
  audioUrl: '',
  imageStation: '',
  idWordPress: '',
  messageChat: '',
  config: {
    type: "",
    message: ""
  },
  contacto: {
    email: '',
    telefono: '',
    direccion: '',
  },
  socialMedia: {
    facebook: '',
    whatsApp: '',
    linkAppAndroid: '',
    linkAppIos: '',
  },
  section: {
    dataHome: '',
    dataAbout: '',
    dataApplication: '',
    dataSocialMedia: '',
    dataProgram: '',
    dataNews: '',
    dataContact: '',
  },
  images: {
    bannerHome: '',
    bannerAbout: '',
    bannerApp: '',
    bannerAppMovil: '',
    bannerNews: '',
  }
};

export const clientConfigurations = {
  DEFAULT: DEFAULT_CONFIG,
  PALABANDA: {
    ...DEFAULT_CONFIG,
    name: 'Pala Banda Radio',
    urlApi: 'https://radiopalabanda.com/api/v2/app',
    skin: 'palabanda',
    excludeId: 'PALABANDA',
    config: {
      type: "2",
      message: "Hola, quiero mandar un saludo."
    },
    contacto: {
      telefono: '7681072176',
      email: 'marketing@palabanda.com.mx',
      direccion: 'Cd Naranjos, Veracruz',
    },
    socialMedia: {
      facebook: 'https://www.facebook.com/PaLaBandaRadio/?locale=es_LA',
      whatsApp: 'Hola,%20envia%20tu%20saludo%20con%20nosotros.',
      linkAppAndroid: 'https://play.google.com/store/apps/details?id=com.iannes.stebsan.palabanda',
      linkAppIos: 'https://apps.apple.com/us/app/pala-banda-radio/id1435568183?l=es&ls=1',
    },
    audioUrl: 'https://iannes.mi-radio.stream:5003/stream',
    imageStation: './assets/palabanda/palabanda.png',
    idWordPress: '4494',
    section: {
      dataAplication: '<p class="px-2">Instala nuestra aplicacion oficial y dejate concentir con las promociones que tenemos para todos nuestros radio escuchas.</p><p class="px-2">No te pierdas de ninguna de nuestras promociones aceptando las notificaciones de la aplicación.</p><p class="px-2">Selecciona la tienda de tu smartphone.</p>'
    },
    images: {
      bannerHome: 'assets/palabanda/banner5.jpg',
      bannerAppMovil: 'assets/palabanda/app_preview.png',
      bannerNews: 'assets/palabanda/news-palabanda.png',
    }
  },
  XHTI: {
    ...DEFAULT_CONFIG,
    name: 'La Huasteca',
    urlApi: 'https://grupoasradio.com.mx/api/v4/app',
    idStation: '998c8f00-0d9c-466a-9b51-fd0d2cfd84f2',
    skin: 'huasteca',
    excludeId: 'XHTI',
    config: {
      type: "2",
      message: "Hola, quiero mandar un saludo."
    },
    imageStation: './assets/huasteca/huasteca.png',
    idWordPress: '4525',
    contacto: {
      email: 'ventas@lahuastecafm.com',
      telefono: '+52 1 789 121 0366',
      direccion: 'Bellavista No. 65 Col. Cerro de la Cruz Tantoyuca, Ver CP 92123',
    },
    socialMedia: {
      facebook: 'https://www.facebook.com/LaHuasteca90.5FM?ref=embed_page',
      whatsApp: 'Hola,%20quiero%20enviar%20un%20saludo.',
      linkAppAndroid: 'https://play.google.com/store/apps/details?id=iannes.grupoasradio',
      linkAppIos: 'https://apps.apple.com/mx/app/grupo-as/id1378856785',
    },
    section: {
      dataAbout: '<p><strong>La Huasteca</strong> en el corazón de Tantoyuca, con el objetivo de brindar entretenimiento musical y contenido informativo que conecte con nuestra audiencia.</p><p>Una estación de radio digital creada para ofrecer una programación variada en géneros musicales, con un enfoque especial en la <strong>música tradicional de la región</strong></p>',
      dataAplication: '<p><strong>Instala la aplicación oficial de Grupo AS</strong> y déjate consentir con las promociones exclusivas que tenemos para todos nuestros radioescuchas.</p><p>No te pierdas ninguna de nuestras promociones aceptando las <strong>notificaciones</strong> de la aplicación.</p><p><strong>Selecciona la tienda</strong> de tu smartphone y disfruta de todo lo que Grupo AS tiene para ti.</p>',
      dataSocialMedia: '',
      dataProgram: '',
      dataNews: '',
      dataContact: '',
    },
    images: {
      bannerHome: 'assets/huasteca/home-huasteca.jpg',
      bannerAbout: 'assets/huasteca/about-huasteca.jpg',
      bannerAppMovil: 'assets/images/app-grupo-as.png',
      bannerNews: 'assets/huasteca/news-huasteca.png',
    }
  },
  XHETO: {
    ...DEFAULT_CONFIG,
    name: 'Romantica XHETO',
    urlApi: 'https://grupoasradio.com.mx/api/v4/app',
    idStation: '74053a0c-0894-4aa5-9774-20d489020862',
    skin: 'romantica-XHETO',
    excludeId: 'XHETO',
    config: {
      type: "2",
      message: "Hola, quiero mandar un saludo."
    },
    audioUrl: '',
    imageStation: './assets/romantica-XHETO/romantica-XHETO.png',
    idWordPress: '4529',
    contacto: {
      email: 'info.tampico@grupoasradio.com',
      telefono: '5218138869136',
      direccion: 'Tampico, Mexico, 89160',
    },
    socialMedia: {
      facebook: 'https://www.facebook.com/romanticatampico/',
      whatsApp: 'Hola,%20envia%20tu%20saludo%20con%20nosotros.',
      linkAppAndroid: 'https://play.google.com/store/apps/details?id=iannes.grupoasradio',
      linkAppIos: 'https://apps.apple.com/mx/app/grupo-as/id1378856785',
    },
    section: {
      dataAbout: '<p><strong>Romántica 98.5 FM</strong>, transmitiendo desde el corazón de Tampico, tiene como objetivo brindar entretenimiento musical y contenido informativo que conecte emocionalmente con nuestra audiencia.</p><p>Una estación de radio digital diseñada para ofrecer una programación variada, con un enfoque especial en la <strong>música que toca el alma</strong>.</p>',
      dataAplication: '<p><strong>Instala la aplicación oficial de Grupo AS</strong> y déjate consentir con las promociones exclusivas que tenemos para todos nuestros radioescuchas.</p><p>No te pierdas ninguna de nuestras promociones aceptando las <strong>notificaciones</strong> de la aplicación.</p><p><strong>Selecciona la tienda</strong> de tu smartphone y disfruta de todo lo que Grupo AS tiene para ti.</p>',
      dataSocialMedia: '',
      dataProgram: '',
      dataNews: '',
      dataContact: '',
    },
    images: {
      bannerHome: 'assets/romantica-XHETO/home-romantica-xheto.png',
      bannerAbout: 'assets/romantica-XHETO/about-romantica-xheto.png',
      bannerAppMovil: 'assets/images/app-grupo-as.png',
      bannerNews: 'assets/romantica-XHETO/news-romantica-xheto.png',
    }
  },
  PERSPECTIVA_TAM: {
    name: 'Perspectiva Tam',
    urlApi: '',
    idStation: '',
    audioUrl: '',
    excludeId: 'PERSPECTIVA_TAM',
    skin: 'perspectiva-tam',
    idWordPress: '4536',
    config: {
      type: "1",
      message: "Compártenos tu reporte."
    },
    imageStation: './assets/perspectiva-tam/perspectiva-tam.png',
    contacto: {
      email: 'contacto@perspectivatam.com',
      telefono: '',
      direccion: 'xxxxxxxxxxxxxxxx',
    },
    socialMedia: {
      facebook: 'https://www.facebook.com/portadatampico',
      whatsApp: 'Hola,%20envia%20tu%20saludo%20con%20nosotros.',
      linkAppAndroid: '',
      linkAppIos: '',
    },
    section: {
      dataAbout: '<p><strong>PerspectivaTam</strong>, en el corazón de Tampico, con el objetivo de brindar información relevante y contenido de calidad que conecte con nuestra audiencia.</p><p>Un medio digital creado para ofrecer cobertura informativa en diversos temas, con un enfoque especial en las <strong>noticias locales y regionales</strong> que impactan a nuestra comunidad.</p>',
      dataAplication: '<p><strong>Instala la aplicación oficial de Grupo AS</strong> y déjate consentir con las promociones exclusivas que tenemos para todos nuestros radioescuchas.</p><p>No te pierdas ninguna de nuestras promociones aceptando las <strong>notificaciones</strong> de la aplicación.</p><p><strong>Selecciona la tienda</strong> de tu smartphone y disfruta de todo lo que Grupo AS tiene para ti.</p>',
      dataSocialMedia: '',
      dataProgram: '',
      dataNews: '',
      dataContact: '',
    },
    images: {
      bannerHome: 'assets/perspectiva-tam/home-perspectiva-tam.png',
      bannerAbout: 'assets/perspectiva-tam/about-perspectiva-tam.png',
      bannerNews: 'assets/perspectiva-tam/news-perspectiva-tam.png',
      bannerAppMovil: 'assets/images/app-grupo-as.png',
    }
  },
  REBEL_NEWS_TAM: {
    name: 'Rebel News Tam',
    urlApi: '',
    idStation: '',
    audioUrl: '',
    excludeId: 'REBEL_NEWS_TAM',
    skin: 'rebel-news-tam',
    idWordPress: '4537',
    config: {
      type: "1",
      message: "Hola, quiero mandar un saludo."
    },
    imageStation: './assets/rebel-news-tam/rebel-news-tam.png',
    contacto: {
      email: 'contacto@rebelnewstam.com',
      telefono: '',
      direccion: 'xxxxxxxxxxxxxxxx',
    },
    socialMedia: {
      facebook: '',
      whatsApp: 'Hola,%20envia%20tu%20saludo%20con%20nosotros.',
      linkAppAndroid: '',
      linkAppIos: '',
    },
    section: {
      dataAbout: '<p><strong>RebelNewsTam</strong> se dedica a proporcionar información relevante y contenido de calidad que conecta con nuestra audiencia.Somos un medio digital creado para ofrecer cobertura informativa en diversos temas, con un enfoque especial en las <strong>noticias locales y regionales</strong> que impactan a nuestra comunidad.</p>',
      dataAplication: '<p><strong>Instala la aplicación oficial de Grupo AS</strong> y déjate consentir con las promociones exclusivas que tenemos para todos nuestros radioescuchas.</p><p>No te pierdas ninguna de nuestras promociones aceptando las <strong>notificaciones</strong> de la aplicación.</p><p><strong>Selecciona la tienda</strong> de tu smartphone y disfruta de todo lo que Grupo AS tiene para ti.</p>',
      dataSocialMedia: '',
      dataProgram: '',
      dataNews: '',
      dataContact: '',
    },
    images: {
      bannerHome: 'assets/rebel-news-tam/home-rebel-news-tam.png',
      bannerAbout: 'assets/rebel-news-tam/about-rebel-news-tam.png',
      bannerNews: 'assets/rebel-news-tam/news-rebel-news-tam.png',
      bannerAppMovil: '',
    }
  },
  PORTADA_TAMPICO: {
    ...DEFAULT_CONFIG,
    name: 'Portada Tampico',
    urlApi: '',
    idStation: '',
    audioUrl: '',
    excludeId: 'PORTADA_TAMPICO',
    skin: 'portada-tampico',
    idWordPress: '4727',
    config: {
      type: "1",
      message: "Compártenos tu reporte."
    },
    imageStation: './assets/portada-tampico/portada-tampico.png',
    contacto: {
      email: 'contacto@perspectivatam.com',
      telefono: 'xxxxxxxxxx',
      direccion: 'xxxxxxxxxxxxxxxx',
    },
    socialMedia: {
      facebook: 'https://www.facebook.com/portadatampico',
      whatsApp: 'Hola,%20envia%20tu%20reporte.',
      linkAppAndroid: '',
      linkAppIos: '',
    },
    section: {
      dataAbout: '<p><strong>Portada Tampico</strong>, el reflejo de la actualidad en el corazón de la ciudad. Te mantenemos informado con <strong>noticias relevantes, análisis profundos</strong> y la mejor cobertura de los acontecimientos que impactan a nuestra comunidad.</p><p>Somos un <strong>medio digital comprometido</strong> con la verdad y la calidad informativa. Con un enfoque especial en las <strong>noticias locales y regionales</strong>, llevamos hasta ti la información más importante de Tampico y sus alrededores. Porque conocer lo que sucede a tu alrededor es el primer paso para estar un paso adelante.</p>',
      dataAplication: '',
      dataSocialMedia: '',
      dataProgram: '',
      dataNews: '',
      dataContact: '',
    },
    images: {
      bannerHome: 'assets/portada-tampico/home-portada-tampico.png',
      bannerAbout: 'assets/portada-tampico/about-portada-tampico.png',
      bannerNews: 'assets/portada-tampico/news-portada-tampico.png',
      bannerAppMovil: '',
    }
  },
};
